import React from "react";
import PropTypes from "prop-types";
import NoResults from "../NoResultsComponent/NoResultsComponent";
import SentencePills from "../NoResultsComponent/SentencePills";

/**
 * EmptyState Molecule - Displays appropriate empty state
 * @component
 * @example
 * <EmptyState
 *   isEmpty={isEmptyResult}
 *   hasNoResults={filteredProducts.length === 0}
 * />
 */
const EmptyState = ({ isEmpty, hasNoResults }) => {
    if (isEmpty) {
        return <NoResults />;
    }

    if (hasNoResults) {
        return <SentencePills />;
    }

    return null;
};

EmptyState.propTypes = {
    isEmpty: PropTypes.bool,
    hasNoResults: PropTypes.bool,
};

export default EmptyState;
